<template>
    <svg x="0px" y="0px" width="60" height="60" viewBox="0 0 60 60" xml:space="preserve" class="icon-arrow-circle" :class="{ 'is-disabled': !enabled }">
        <path class="arrow" d="M26.3,34.6l4.6-4.6l-4.6-4.6l1.4-1.4l6,6l-6,6L26.3,34.6z"/>
        <path :fill="colorHex" class="circle" d="M30,2c15.4,0,28,12.6,28,28c0,15.4-12.6,28-28,28S2,45.4,2,30C2,14.6,14.6,2,30,2 M30,0C13.4,0,0,13.4,0,30 c0,16.6,13.4,30,30,30c16.6,0,30-13.4,30-30C60,13.4,46.6,0,30,0L30,0z"/>
    </svg>
</template>
<script>
import config from '@/config'

export default
{
    props:
    {
        enabled: {
            type: Boolean,
            default: true
        },

        color: {
            type: String,
            default: 'blue',
            validator: color => Object.keys(config.colors).indexOf(color) > -1
        }
    },

    computed:
    {
        colorHex()
        {
            return config.colors[this.color]
        }
    }
}
</script>
<style lang="sass" scoped>
@import "../../style/_settings/__index.sass"
@import "../../style/_required/_index.sass"

.arrow
    .icon-arrow-circle.is-disabled &
        fill: rgba(#000, 0.2)

.circle
    .icon-arrow-circle.is-disabled &
        fill: rgba(#000, 0.2)

</style>
